module.exports = __webpack_public_path__ + "static/media/collection-bird-08-effect.df4ad7c0.png";